import axios from "axios";
import { baseApi } from "../redux/baseAPI";
export const triageApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTriage: builder.query({
      query: (data) => {
        return {
          url: `/Appointments/triage.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => {
        return { data: response.response.data, meta: response.response.meta };
      },
      providesTags: ["TriagesData"],
    }),
    updateTriage: builder.mutation({
      query: (body) => ({
        url: "/appointments/triage_update_status.json",
        method: "POST",
        data: body,
      }),
    }),
    getTriageMeta: builder.query({
      query: (queryParams = null) => {
        return {
          url: `/appointments/options_list.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => {
        return { data: response.response.data, meta: response.response.meta };
      },
    }),
    upcommingAppointmentJson: builder.query({
      query: (queryParams = null) => {
        return {
          url: `/appointments/patient_upcoming_appointments.json`,
          method: "GET",
          params: queryParams,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    deleteAppointment: builder.mutation({
      query: (body) => ({
        url: "/appointments/delete.json",
        method: "POST",
        data: body,
      }),
    }),
    getTriageDetailByLocation: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/triage_location_settings.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["getLocationData"],
    }),
    updateTriageLocationDetail: builder.mutation({
      query: (data) => ({
        url: "/appointments/triage_location_settings.json",
        method: "POST",
        data: data,
      }),
      invalidatesTags: ["getLocationData"],
    }),
    getfeeSchedule: builder.query({
      query: (queryParams = null) => ({
        url: "/fee_schedules/search_fee_schedule_cpts.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getTypeServices: builder.query({
      query: (queryParams = null) => ({
        url: "/utilities/listing/type_of_service.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getPatientInsurances: builder.query({
      query: (queryParams = null) => ({
        url: "/demographics/patient_insurances.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags:['GetPatientInsurances']
    }),
    getPatientEligibilities: builder.query({
      query: (queryParams = null) => ({
        url: "/patient_eligibilities/check_eligibility.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getInsurancePlan: builder.query({
      query: (queryParams = null) => ({
        url: "/insurance_plans/lookup.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getTriagePatients: builder.query({
      query: (queryParams = null) => ({
        url: "/patients/index.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    printScheduler: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/print_scheduler.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    printDailyTriage: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/print_daily_triage.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    printAverageTriageReport: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/triage_average_report.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    patientEligibilityHistory: builder.query({
      query: (queryParams = null) => ({
        url: "/patient_eligibilities/patient_eligibilities_history.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),

    getClearingHouseLookUp: builder.query({
      query: (queryParams = null) => ({
        url: "/clearing_houses/lookup.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    triageHistory: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/triage_appointment_history.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getPaymentType: builder.query({
      query: (queryParams = null) => ({
        url: "/utilities/listing/payment_types.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getCardTypes: builder.query({
      query: (queryParams = null) => ({
        url: "/utilities/listing/credit_card_types.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getAppointmentById: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/getAppointmentById.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getPaymentKeys: builder.mutation({
      query: (body) => ({
        url: "/secure_payments/ethizo_gateway_configs.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    savePayment: builder.mutation({
      query: (body) => ({
        url: "/patient_payments/save_print.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    manualPrint: builder.mutation({
      query: (body) => ({
        url: "/secure_payments/manual_invoice.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    resetAdvancePayment: builder.mutation({
      query: (body) => ({
        url: "/patient_advance_payments/save.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    tasksMeta: builder.query({
      query: (queryParams = null) => ({
        url: "/tasks/settings.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getGroups: builder.query({
      query: (queryParams = null) => ({
        url: "/tasks/get_groups.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["GetGroups"],
    }),

    deleteGroup: builder.mutation({
      query: (body) => ({
        url: "/tasks/delete_group.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      invalidatesTags: ["GetGroups"],
    }),
    addGroup: builder.mutation({
      query: (body) => ({
        url: "/tasks/add_group.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ["GetGroups"],
    }),
    addTasks: builder.mutation({
      query: (body) => ({
        url: "/tasks/add.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    getTasks: builder.query({
      query: (queryParams = null) => ({
        url: "/tasks/get_task.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    addVisitNotes: builder.mutation({
      query: (body) => ({
        url: "/appointments/add_provider_visit_notes.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ["TriagesData"],
    }),
    getPatientContact: builder.query({
      query: (queryParams = null) => ({
        url: "/patients/contacts.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    addAppointment: builder.mutation({
      query: (body) => ({
        url: "/appointments/add_appointment.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags:["TriagesData"]
    }),
    addEfaxContact: builder.mutation({
      query: (body) => ({
        url: "/fax_address_book/add.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    getTriageNotes: builder.query({
      query: (params) => ({
        url: "/patients/triage_notes.json",
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getPatientShareTriageNotes: builder.query({
      query: (params) => ({
        url: "/patients/patient_share_triage_notes.json",
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getTriageNoteMeta: builder.query({
      query: (params) => ({
        url: "/patients/triage_notes_meta.json",
        method: "GET",
        params: params,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    addTriageNote: builder.mutation({
      query: (body) => ({
        url: "/patients/add_triage_note.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
  }),
});

export function getEfaxContact(data) {
  return axios.get(
    `${process.env.REACT_APP_API_URL_V1}/fax_address_book/index.json?keyword=${data?.keyword}`
  );
}

export const {
  useGetTriageQuery,
  useGetTriageMetaQuery,
  useUpdateTriageMutation,
  upcommingAppointmentJsonQuery,
  useDeleteAppointmentMutation,
  useGetTriageDetailByLocationQuery,
  useUpdateTriageLocationDetailMutation,
  useGetfeeScheduleQuery,
  useGetTypeServicesQuery,
  useGetPatientInsurancesQuery,
  useGetPatientEligibilitiesQuery,
  useGetInsurancePlanQuery,
  useGetTriagePatientsQuery,
  usePrintSchedulerQuery,
  usePrintAverageTriageReportQuery,
  usePatientEligibilityHistoryQuery,
  useGetClearingHouseLookUpQuery,
  useTriageHistoryQuery,
  useGetPaymentTypeQuery,
  useGetCardTypesQuery,
  useGetAppointmentByIdQuery,
  useGetPaymentKeysMutation,
  useSavePaymentMutation,
  useManualPrintMutation,
  useResetAdvancePaymentMutation,
  useTasksMetaQuery,
  useGetGroupsQuery,
  useDeleteGroupMutation,
  useAddGroupMutation,
  useAddTasksMutation,
  useGetTasksQuery,
  useAddVisitNotesMutation,
  useGetPatientContactQuery,
  useAddAppointmentMutation,
  useAddEfaxContactMutation,
  useGetTriageNotesQuery,
  useGetPatientShareTriageNotesQuery,
  useGetTriageNoteMetaQuery,
  useAddTriageNoteMutation
} = triageApi;
